(function () {
  'use strict';

  var PROPERTY_KEYS = {
    source: '_km_source',
    audience: '_km_audience',
    funnel: '_km_funnel'
  };

  function cleanToken(value, allowed, maxLength) {
    var token = String(value || '').trim().toUpperCase();
    if (allowed.indexOf(token) === -1) return '';
    return token.slice(0, maxLength || 20);
  }

  function cleanFunnel(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 100);
  }

  function getContext() {
    var configured = window.KM_PURCHASE_CONTEXT || {};
    var source = cleanToken(configured.source, ['HP', 'PDP', 'LP']);
    var audience = configured.audience || '';
    var funnel = configured.funnel || '';

    if (source === 'LP') {
      try {
        var params = new URLSearchParams(window.location.search);
        audience = params.get('km_audience') || audience;
        funnel = params.get('km_funnel') || funnel;
      } catch (error) {
        // Keep the Liquid-provided defaults when URLSearchParams is unavailable.
      }
    }

    return {
      source: source,
      audience: source === 'LP' ? cleanToken(audience, ['GLP1', 'MENO', 'GEN', "POSTPARTUM"]) : '',
      funnel: source === 'LP' ? cleanFunnel(funnel) : ''
    };
  }

  function getProperties() {
    var context = getContext();
    var properties = {};

    if (!context.source) return properties;

    properties[PROPERTY_KEYS.source] = context.source;
    if (context.source === 'LP') {
      if (context.audience) properties[PROPERTY_KEYS.audience] = context.audience;
      if (context.funnel) properties[PROPERTY_KEYS.funnel] = context.funnel;
    }

    return properties;
  }

  function decorateItem(item) {
    if (!item || typeof item !== 'object') return item;

    var properties = getProperties();
    var keys = Object.keys(properties);
    if (!keys.length) return item;

    item.properties = item.properties || {};
    keys.forEach(function (key) {
      item.properties[key] = properties[key];
    });

    return item;
  }

  function decoratePayload(payload) {
    if (!payload || typeof payload !== 'object') return payload;

    if (Array.isArray(payload.items)) {
      payload.items.forEach(decorateItem);
      return payload;
    }

    if (payload.id || payload.variant_id) decorateItem(payload);
    return payload;
  }

  function setFormDataProperties(formData) {
    var properties = getProperties();
    Object.keys(properties).forEach(function (key) {
      formData.set('properties[' + key + ']', properties[key]);
    });
    return formData;
  }

  function setSearchParamsProperties(params) {
    var properties = getProperties();
    var itemIndexes = {};

    params.forEach(function (_value, key) {
      var match = key.match(/^items\[(\d+)\]\[/);
      if (match) itemIndexes[match[1]] = true;
    });

    var indexes = Object.keys(itemIndexes);
    Object.keys(properties).forEach(function (key) {
      if (indexes.length) {
        indexes.forEach(function (index) {
          params.set('items[' + index + '][properties][' + key + ']', properties[key]);
        });
      } else {
        params.set('properties[' + key + ']', properties[key]);
      }
    });

    return params;
  }

  function decorateCartAddUrl(url) {
    if (!url || !Object.keys(getProperties()).length) return url;

    var original = String(url);
    var absolute = /^[a-z][a-z0-9+.-]*:\/\//i.test(original);
    var parsed;

    try {
      parsed = new URL(original, window.location.origin);
    } catch (error) {
      return url;
    }

    if (!/\/cart\/add(?:\.js)?\/?$/.test(parsed.pathname)) return url;

    setSearchParamsProperties(parsed.searchParams);
    return absolute ? parsed.toString() : parsed.pathname + parsed.search + parsed.hash;
  }

  function isCartAddUrl(input) {
    var value = typeof input === 'string' ? input : input && input.url;
    if (!value) return false;

    try {
      return /\/cart\/add(?:\.js)?\/?$/.test(new URL(value, window.location.origin).pathname);
    } catch (error) {
      return false;
    }
  }

  function decorateForm(form) {
    if (!form || !isCartAddUrl(form.action)) return;

    var properties = getProperties();
    Object.keys(properties).forEach(function (key) {
      var name = 'properties[' + key + ']';
      var input = form.querySelector('input[name="' + name + '"]');

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }

      input.value = properties[key];
      input.disabled = false;
    });
  }

  function decorateForms(root) {
    if (!root || !Object.keys(getProperties()).length) return;

    if (root.matches && root.matches('form[action*="/cart/add"]')) decorateForm(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('form[action*="/cart/add"]').forEach(decorateForm);
    }
  }

  window.KMAttribution = {
    getContext: getContext,
    properties: getProperties,
    decorateItem: decorateItem,
    decoratePayload: decoratePayload,
    decorateCartAddUrl: decorateCartAddUrl,
    decorateForms: decorateForms
  };

  if (window.fetch) {
    var nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      if (!isCartAddUrl(input) || !Object.keys(getProperties()).length) {
        return nativeFetch.apply(this, arguments);
      }

      // A Request instance can already contain a consumed stream body. Leave it
      // untouched instead of accidentally converting a POST into a GET.
      if (typeof input !== 'string' && input && input.method && !init) {
        return nativeFetch.apply(this, arguments);
      }

      var nextInput = input;
      var nextInit = init ? Object.assign({}, init) : {};
      var body = nextInit.body;

      if (!body && (!nextInit.method || String(nextInit.method).toUpperCase() === 'GET')) {
        nextInput = decorateCartAddUrl(typeof input === 'string' ? input : input.url);
      } else if (body instanceof FormData) {
        nextInit.body = setFormDataProperties(body);
      } else if (body instanceof URLSearchParams) {
        nextInit.body = setSearchParamsProperties(body);
      } else if (typeof body === 'string') {
        var parsedBody = null;

        try {
          parsedBody = JSON.parse(body);
        } catch (jsonError) {
          try {
            var params = new URLSearchParams(body);
            nextInit.body = setSearchParamsProperties(params).toString();
          } catch (paramsError) {
            parsedBody = null;
          }
        }

        if (parsedBody) nextInit.body = JSON.stringify(decoratePayload(parsedBody));
      }

      return nativeFetch.call(this, nextInput, nextInit);
    };
  }

  document.addEventListener('submit', function (event) {
    decorateForm(event.target);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      decorateForms(document);
    });
  } else {
    decorateForms(document);
  }

  if (window.MutationObserver && document.documentElement) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(decorateForms);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
